import { observable, action, toJS } from "mobx";
import { isDataExist } from "Utils/dataTools";
import * as services from "../services/home";
import { isEmpty, uniqBy, omit } from "lodash";
import { checkCurrentMenu } from "utils/dataTools";
import { MenuObj } from "../constants/configs";
import { message } from "antd";
class Home {
  /* 其他变量 */
  @observable contentScrollHeight = 0; //当前content滚动高度
  @observable collapsed = false;
  @observable menuObj = [];
  @observable openKeys = ["1"]; // 菜单初始化默认打开的key数组
  @observable selectedKeys = ["101"]; // 菜单初始化默认选中的key数组
  @observable crumbsList = []; // 全局crumbs需求
  @observable size_class = "";
  @observable isClickCollapsed = false;
  @observable isRecommend = true; // 是否需要推荐菜单
  @observable customMenu = []; // 首页自定义菜单
  @observable isLoading = false;
  @observable toggledActionId = 0;
  @observable isThemeLoading = false; //设置切换主题的loading
  @observable isSwitchTheme = {};
  @observable emptyDesc = "正在加载中";
  @observable macs='';
  @observable username=''
  @observable jurisdiction={} //特殊权限用于仓库管理入库管理和出库管理的tab页权限
  // @observable Tabs = "";  //特殊权限用于仓库管理入库管理Tab页的权限
  // @observable Tabs1 = "";  //特殊权限用于仓库管理出库管理Tab页的权限
  /* 设置登陆信息 */
  @action async setLogin(params, finished) {
    console.log('params',params,finished,'finished')
    this.isLoading = true;
    let result = { success: false, token: null };
    try {
      sessionStorage.setItem("token", "Basic cGM6c2VjcmV0");
      let res = await services.postsForm("setLogin")({
        ...params
      });
      this.isLoading = false;
      console.log('resssss')
      if (isDataExist(res)) {
        let data = res.data.data;
        sessionStorage.setItem("tenantId", res.data.dataExt.tenantId);
        console.log('data',data)
        if (data.access_token && data.token_type) {
          let token = `${data.token_type}${data.access_token}`;
          result.success = true;
          result.token = token;
        }
      }
    } catch (error) {
      console.log(error);
    }
    if (finished) finished(result);
  }
  // 退出登录
  @action async setLogout(params){
    // console.log(params,'params')
    this.isLoading = true;
    try {
      let res = await services.posts('setLogout')({
        ...params,
      })
      this.isLoading = false;
      if(isDataExist(res)){
        let data = res.data.data
      }
    } catch (error) {
      console.log(error)
    }
  }

  /** 请求mac地址 */
  // @action async getMac(params){
  //   console.log('111111111','99999999999')
  //   fetch('http://127.0.0.1:8892/api/getMacs',{
  //     method:'GET',
  //  }).then((res)=>{
  //    console.log(res,'res111111')
  //    return res.text();
  //  }).then(data=>{
  // this.macs=data
  //  console.log(data,'data1111')
  //  }).catch(err=>console.log(err,'err'))
  // }
  /* mac地址校验 */
  // @action async getCheckMac(){

  // }
  /* 首页初始化获取菜单信息 */
  @action async getMenuList(params) {

    this.isLoading = true;
    let menuObj = MenuObj.leafMenuModels;
    try {
      let res = await services.gets("getMenuList")({ id: 0, clientType: 0 });
      this.isLoading = false;
      if (isDataExist(res)) {
        if (res.data.data) {
          // ----------
          res.data.data.childMenu.map(item=>{
            if(item.name==='特殊权限'){
              this.jurisdiction=item
          }
          })
// -----------------
          localStorage.setItem("tenantId", res.data.data.tenantId);
          let data = res.data.data.childMenu;
          /* 初始化开发 菜单项 */
          menuObj.map(lv => {
            Object.assign(lv, {
              displayNone: true
            });
            if (!lv.displayNone) {
              Object.assign(lv, {
                displayNone: false
              });
              if (lv.leafMenuModels) {
                lv.leafMenuModels.map(lv2 => {
                  Object.assign(lv2, {
                    displayNone: false
                  });
                });
              }
            }
          });

          /* 一级菜单 */
          menuObj.map(lv => {
            Object.assign(lv, {
              displayNone: true
            });
            data.map(item => {
              if (lv.name === item.name) {
                if (item.childMenu) {
                  lv.children = item.childMenu;
                }
                Object.assign(lv, {
                  treeId: item.id,
                  displayNone: false
                });
              }
            });
          });
          /* 二级菜单 */
          menuObj.map(lv => {
            if (!lv.displayNone) {
              Object.assign(lv, {
                displayNone: false
              });
              if (lv.leafMenuModels) {
                lv.leafMenuModels.map(lv2 => {
                  Object.assign(lv2, {
                    displayNone: true
                  });
                  if (!isEmpty(lv.children)) {
                    lv.children
                      .filter(item => item.parentId === lv.treeId)
                      .filter(item => item.name === lv2.name)
                      .map(child => {
                        Object.assign(lv2, {
                          displayNone: false
                        });
                      });
                  }
                });
              }
            }
          });
        } else {
          menuObj = [];
          this.emptyDesc = "很抱歉，您暂无系统任何权限，请联系管理员添加";
        }
        this.menuObj = menuObj;
        console.log(menuObj, "menuObj");
      }
    } catch (error) {
      console.log("获取menu:", error);
    }
  }

  /* 菜单加载的初始化 */
  @action initMenu(pathname) {
    if (pathname === "/order") pathname = "/order/query";
    try {
      let menuObj = toJS(this.menuObj);
      let currentMenu = [],
        crumbsList = [];
      /* 菜单查询 */
      currentMenu = menuObj.filter(leaf => leaf.path === pathname);
      if (isEmpty(currentMenu)) {
        currentMenu = menuObj.filter(lv => pathname.indexOf(lv.path) > -1);
      }
      if (!isEmpty(currentMenu)) {
        for (let lv of currentMenu) {
          /* 面包屑的数据接入 */
          crumbsList.push({
            id: lv.id,
            name: lv.name,
            path: lv.path
          });
          /* 校验菜单路径 */
          if (lv.path === pathname) {
            this.selectedKeys = [`${lv.id}`];
            this.openKeys = [`${lv.parentId}`];
          } else {
            /* 判断二级 */
            lv.leafMenuModels.map(lv2 => {
              if (lv2.path === pathname) {
                this.selectedKeys = [`${lv2.id}`];
                this.openKeys = [`${lv2.parentId}`];
                crumbsList.push({
                  id: lv2.id,
                  name: lv2.name,
                  path: lv2.path
                });
              } else {
                if (lv2.activeRouter) {
                  if (lv2.activeRouter.indexOf(pathname) > -1) {
                    this.selectedKeys = [`${lv2.id}`];
                    this.openKeys = [`${lv2.parentId}`];
                  }
                } else {
                  /* 判断三级 */
                  if (!isEmpty(lv2.leafMenuModels)) {
                    lv2.leafMenuModels.map(lv3 => {
                      if (lv3.path === pathname) {
                        this.selectedKeys = [`${lv3.id}`];
                        this.openKeys = [`${lv2.parentId}`];
                      }
                    });
                  }
                }
              }
            });
          }
        }
      }
      let history = sessionStorage.getItem("menu") || [];
      if (!isEmpty(history)) {
        history = JSON.parse(history);
        history = uniqBy(history, "id");
      }
      sessionStorage.setItem("menu", JSON.stringify(history));
      this.crumbsList = crumbsList;
    } catch (error) {
      console.log(error);
    }
  }
  @action toggleMenu({ actionItem, actionId }, finished) {
    try {
      let menuObj = toJS(this.menuObj); // 根菜单节点
      actionId = parseInt(actionId);
      /* 查询当前菜单item */
      let current = checkCurrentMenu({ menuObj, actionId });
      let currentMenu = current.currentMenu,
        crumbsList = current.crumbsList;
      finished(currentMenu[0].path);
      this.crumbsList = crumbsList;
      /* 记录历史-浏览记录 */
      this.setLastMenuHistory(currentMenu[0], actionId);
      this.toggledActionId = currentMenu[0].id;
      this.selectedKeys = [`${currentMenu[0].id}`];
      this.openKeys = [`${currentMenu[0].parentId || currentMenu[0].rootId}`];
    } catch (error) {
      console.log(error);
    }
  }
  setLastMenuHistory = (actionItem, actionId) => {
    let history = sessionStorage.getItem("menu") || [];
    let index = -1;
    if (!isEmpty(history)) history = JSON.parse(history);
    for (let i = 0; i < history.length; i++) {
      if (history[i].id === actionId) {
        index = i;
      }
    }
    if (index > -1) {
      history.splice(index, 1);
    }
    history.push(actionItem);
    if (history.length >= 4) {
      history.splice(0, 1);
    }
    history = uniqBy(history, "id");
    sessionStorage.setItem("menu", JSON.stringify(history));
  };

  @action.bound async savePassword(params) {
    try {
      let res = await services.posts("savePassword")(params);
      if (isDataExist(res)) {
        message.success("更新成功");
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action.bound async saveBasicInfo(params) {
    try {
      let res = await services.posts("saveBasicInfo")(params);
      if (isDataExist(res)) {
        message.success("更新成功");
      }
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound addCrumbs(obj) {
    this.crumbsList.push(obj);
  }

  @action changeValue(key, value) {
    this[key] = value;
  }

  /*  生产分析 */
  @observable AnalysisData = [];
  @action async getAllStaticCount() {
    try {
      let resArray = [
        { req: "getMonthPlanCount", data: {}, type: "planVars" },
        { req: "getMonthWorkCount", data: {}, type: "workVars" },
        { req: "getDayWorkCont", data: {}, type: "execVars" },
        { req: "getDaySuccessCount", data: {}, type: "factVars" }
      ];
      for (let req of resArray) {
        let params = req.params || {};
        let res = await services.gets(req.req)(params);
        if (isDataExist(res)) {
          let data = res.data.data;
          if (req.type === "workExecute") {
            let list = [{ name: "successCount" }, { name: "failCount" }];
            for (let item of data) {
              list[0][item.reportTime] = item.successCount;
              list[1][item.reportTime] = item.failCount;
            }
            Object.assign(req, {
              data: list
            });
          } else if (req.type === "productStatic") {
            let list = [];
            for (let item of data) {
              list.push({
                year: item.reportTime,
                value: item.successCount
              });
            }
            Object.assign(req, {
              data: list
            });
          } else {
            Object.assign(req, {
              data
            });
          }
        }
      }

      this.AnalysisData = resArray;
    } catch (error) {}
  }
}
let HomeStore = new Home();
export default HomeStore;
